const SHIM_INSTALLED_KEY = '__NYL_IOS_WEBVIEW_BRIDGE_SHIM__';
const NOOP_MESSAGE_HANDLER = {postMessage: () => {}};

const realMessageHandlersByProxy = new WeakMap();

function createMessageHandlersProxy(existingHandlers = {}) {
  const proxy = new Proxy(existingHandlers, {
    get(target, prop) {
      if (typeof prop === 'symbol') {
        return undefined;
      }

      const handler = target[prop];
      return handler && typeof handler.postMessage === 'function'
        ? handler
        : NOOP_MESSAGE_HANDLER;
    },
  });

  realMessageHandlersByProxy.set(proxy, existingHandlers);
  return proxy;
}

function getRegisteredMessageHandler(handlerName) {
  const handlers = window.webkit?.messageHandlers;
  const registeredHandlers = realMessageHandlersByProxy.get(handlers) || handlers;

  if (!registeredHandlers || typeof registeredHandlers !== 'object') {
    return null;
  }

  const handler = registeredHandlers[handlerName];
  return handler && typeof handler.postMessage === 'function' ? handler : null;
}

/**
 * iOS WKWebView exposes native bridges on window.webkit.messageHandlers.
 * Some tags and integrations read it unconditionally; on desktop and standard
 * mobile browsers window.webkit is undefined and those reads throw.
 */
export function installIosWebViewBridgeShim() {
  if (typeof window === 'undefined' || window[SHIM_INSTALLED_KEY]) {
    return;
  }

  try {
    let webkit = window.webkit;

    if (!webkit || typeof webkit !== 'object') {
      window.webkit = {messageHandlers: createMessageHandlersProxy()};
      window[SHIM_INSTALLED_KEY] = true;
      return;
    }

    webkit.messageHandlers = createMessageHandlersProxy(webkit.messageHandlers);
    window[SHIM_INSTALLED_KEY] = true;
  } catch (e) {
    // Some environments block redefining window properties.
  }
}

export function hasIosWebViewBridge(handlerName) {
  if (!handlerName) {
    return false;
  }

  try {
    return Boolean(getRegisteredMessageHandler(handlerName));
  } catch (e) {
    return false;
  }
}

export function postToIosWebView(handlerName, payload) {
  try {
    const handler = getRegisteredMessageHandler(handlerName);
    if (!handler) {
      return false;
    }

    handler.postMessage(payload);
    return true;
  } catch (e) {
    return false;
  }
}

